import * as React from "react";
export const WholeIcon = (props) => {
    return (
    // <svg viewBox="250.905 134.349 22 22" width={15} height={22} {...props}>
    //   <path
    //     clipRule="evenodd"
    //     d="M272.905 145.349c0 6.05-4.95 11-11 11s-11-4.95-11-11 4.95-11 11-11 11 4.95 11 11z"
    //     paintOrder="fill"
    //     fillRule="evenodd"
    //     fill={props.fill}
    //   />
    // </svg>
    React.createElement("svg", { width: "12", height: "12" },
        React.createElement("circle", { cx: "6", cy: "6", r: "6", fill: "#FF0000" })));
};
export const HalfIcon = (props) => {
    return (React.createElement("svg", { width: "7", height: "12" },
        React.createElement("circle", { cx: "6", cy: "6", r: "6", fill: "#FF0000" })));
};
//# sourceMappingURL=coverage.js.map